<template>
  <div class="bg" v-bind:style="{ backgroundColor: (step === 'genres' || step === 'moods') ? '#dc3681' : '#fff'}">
    <div class="header">
      <div class="logo">
        <img src="/static/img/songback-logo.svg" class="logo">
      </div>
      <div class="cancel" @click="close" v-if="step === 'create'">
        <font-awesome-icon icon="times"/>
      </div>
    </div>
    <div class="content">
      <div class="wizard">
        <div class="panel begin" v-if="step === 'create'">
          <div class="message">
            <h1>Welcome Artist</h1>
            <p class="text">
              This is where your journey begins.
              You have a HUGE responsibility, your
              content will be the heart of yours and
              our business. Try to impress your fans!
            </p>
            <p class="actions d-md-block d-none">
              <a href="#" class="cancel" @click="close">cancel</a>
              <b-button type="submit" class="btn-decorated" @click="create" :disabled="!artist.tos || !artist.handle">Start</b-button>
            </p>
            <p class="d-md-block d-none">
              <b-form-checkbox id="checkbox1"
                               v-model="artist.tos"
                               required>
                  I accept the <a href="/site/tos" target="_blank">Terms of Use</a>
              </b-form-checkbox>
            </p>
          </div>
          <div class="form">
            <b-form-group id="nameGroup"
                          label="Choose your artistic name"
                          :state="fieldState('name')"
                          :invalid-feedback="fieldError('name')"
                          label-for="name">
              <b-form-input id="name" type="text" required v-model="artist.name" :state="fieldState('name')" />
            </b-form-group>
            <b-form-group id="handleGroup"
                          label="Artist handle (may match your username)"
                          label-for="handle"
                          :state="fieldState('handle')"
                          :invalid-feedback="fieldError('handle')">
              <b-form-input id="handle" type="text" required v-model="artist.handle" :state="fieldState('handle')" />
            </b-form-group>
            <b-form-group id="emailGroup"
                          label="Contact email (will be visible on receipts)"
                          label-for="email"
                          :state="fieldState('email')"
                          :invalid-feedback="fieldError('email')">
              <b-form-input id="email" type="email" required v-model="artist.email" :state="fieldState('email')" />
            </b-form-group>
            <b-form-group id="locationGroup"
                          label="Where are you from?"
                          label-for="location">
              <vue-google-autocomplete id="location"
                                       classname="form-control"
                                       placeholder="Start typing"
                                       types="(cities)"
                                       v-on:placechanged="onPlaceChanged" />
            </b-form-group>
            <b-form-group id="bioGroup"
                          label="Tell your story"
                          label-for="bio">
              <b-form-textarea id="bio" :rows="5" :max-rows="10" required placeholder="" v-model="artist.bio"></b-form-textarea>
            </b-form-group>
            <p class="actions align-items-center d-block d-flex d-md-none justify-content-between">
              <a href="#" class="cancel" @click="close">cancel</a>
              <b-button type="submit" class="btn-decorated" @click="create" :disabled="!artist.tos || !artist.handle || !artist.email">Start</b-button>
            </p>
            <p class="d-md-none d-block">
              <b-form-checkbox id="checkbox1"
                               v-model="artist.tos"
                               required>
                  I accept the <a href="/site/tos" target="_blank">Terms of Use</a>
              </b-form-checkbox>
            </p>
          </div>
        </div>

        <div class="panel genres" v-if="step === 'genres'">
          <div class="message">
            <h1>Help your fans find you</h1>
            <p class="text">Choose which genres match your style.</p>
            <p class="align-items-center d-md-flex justify-content-around d-md-block d-none actions">
              <b-button type="submit" class="btn-decorated" @click="saveGenres">Next</b-button>
              <LinkButton :u="true" @click="step = 'moods'" class="m-0">skip</LinkButton>
            </p>
          </div>
          <div class="form">
            <b-button v-for="genre in genres" :key="genre" :pressed.sync="genreMap[genre]" @click="onGenre(genre)">
              {{ genre }}
            </b-button>
            <div class="info">(Choose up to 3)</div>
            <p class="align-items-center justify-content-around d-md-none d-flex actions">
              <b-button type="submit" class="btn-decorated" @click="saveGenres">Next</b-button>
              <LinkButton :u="true" @click="step = 'moods'" class="m-0">skip</LinkButton>
            </p>
          </div>
        </div>

        <div class="panel genres" v-if="step === 'moods'">
          <div class="message">
            <h1>Mood is everything</h1>
            <p class="text">What should your fans feel?</p>
            <p class="align-items-center d-md-flex justify-content-around d-md-block d-none actions">
              <b-button type="submit" class="btn-decorated" @click="saveMoods">Next</b-button>
              <LinkButton :u="true" @click="step = 'payout'" class="m-0">skip</LinkButton>
            </p>
          </div>
          <div class="form">
            <b-button v-for="mood in moods" :key="mood" :pressed.sync="moodMap[mood]" @click="onMood(mood)">
              {{ mood }}
            </b-button>
            <div class="info">(Choose up to 2)</div>
            <p class="align-items-center justify-content-around d-md-none d-flex actions">
              <b-button type="submit" class="btn-decorated" @click="saveMoods">Next</b-button>
              <LinkButton :u="true" @click="step = 'payout'" class="m-0">skip</LinkButton>
            </p>
          </div>
        </div>

        <div class="panel payout" v-if="step === 'payout'">
          <div class="message">
            <h1>Monetize your art</h1>
            <p class="text">Set up your payout method to earn money live streaming shows or private concerts, releasing new songs, and receiving donations. (see <router-link :to="{name: 'site-fees'}" target="_blank">Artist Fees and Payments</router-link>
            for details)</p>
          </div>
          <div class="form">
             <b-button type="submit" class="btn-rainbow" @click="setupStripe">set up payouts</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .bg {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: url('/static/img/artist-workspace-hero.jpg');
    background-size: cover;
    z-index: $zindex-fullscreen;

    display: flex;
    flex-direction: column;
    align-items: stretch;
    @include media-breakpoint-down(sm) {
      position: absolute;
      top: -48px;
      left: 0px;
      bottom: auto;
      background: #fff;
      right: 0;
      min-height: 100vh;
    }

    .header {
      width: 100%;
      padding: 2em;
      display: flex;

      .logo {
        flex: 1;
        text-align: left;
        height: 35px;
      }

      .cancel {
        flex: 0;
        text-align: right;
        @include media-breakpoint-down(sm) {
          svg {
            filter: invert(1);
            position: absolute;
            z-index: 9999;
          }
        }
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;

    .wizard {
      margin: -5em auto 0 auto;
      position: relative;
      max-width: 50em;

      &:before {
        content: ' ';
        position: absolute;
        left: 1.5em;
        right: -1.5em;
        top: -1em;
        bottom: 1em;

        background: transparent;
        border: 2px solid $white;
        z-index: $zindex-fullscreen;
      }
      @include media-breakpoint-down(sm) {
        margin: -8em auto 0 auto;
        padding-top: 5em;
        &:before {
          content: none;
        }
      }

      .panel {
        position: relative;
        z-index: $zindex-fullscreen + 1;
        background: $white;
        color: black;
        display: flex;
        flex-direction: row;
        @include media-breakpoint-down(sm) {
          flex-direction: column;
        }
      }

      h1 {
        font-size: 3.8em;
        font-family: 'AvenirHeavy';
        margin: 0 0 3.5rem 0;
        max-width: 262px;
        color: #29293d;
        line-height: 1;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          bottom: -30px;
          height: 7px;
          width: 65px;
          background: #29293d;
        }
        @include media-breakpoint-down(sm) {
          max-width: 100%;
          font-size: 2.4em;
          margin: 0 0 3rem 0;
          &:before {
            height: 5px;
            bottom: -20px;
          }
        }
      }
      .message,
      .form {
        padding: 2em;
        flex: 1;
        display: flex;
        flex-direction: column;

        .btn-decorated {
          padding-left: 3em;
          padding-right: 3em;
        }
        .cancel {
          color: black;
          text-decoration: underline;
        }

        .text {
          flex: 1;
          line-height: 2;
          @include media-breakpoint-down(sm) {
            font-size: 0.9em;
            line-height: 1.8;
          }
        }
        .actions {
          margin-top: 1em;
          margin-bottom: 2em;
          width: 100%;
          justify-content: center !important;
          .btn {
            margin-right: 2em !important;
            margin-left: 2em !important;
          }
        }
      }
      .message {
        @include media-breakpoint-down(sm) {
          padding-bottom: 0;
        }
      }

      .form {
        padding: 2em;
        flex: 1;
        .info {
          position: absolute;
          bottom: 12px;
          font-weight: bold;
          font-size: .9rem;
          @include media-breakpoint-down(sm) {
            bottom: 110px;
          }
        }
      }

      .payout .form {
        text-align: center;
        background: center url(/static/img/card-placeholder.png) no-repeat;
        background-size: contain;

        display: flex;
        justify-content: center;
        align-items: center;
      }

      .genres {
        background: #dc3681;
        color: #fff;
        @include media-breakpoint-down(sm) {
          margin-top: -30px;
          min-height: 95vh;
        }

        h1 {
          color: #fff;
          &:before {
            background: #fff;
          }
        }
        .btn-secondary {
          background: transparent !important;
          color: #fff !important;
          border-color: #fff;
          box-shadow: none !important;
          font-weight: bold;
          &.active {
            background: linear-gradient(107deg, #1d6fcd, #4cc6cf) !important;
            box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.64) !important;
          }
        }
        .message,
        .form {
          .btn-decorated {
            background: #fff !important;
            color: #111 !important;
            &:before {
              border-color: #fff !important;
            }
          }
        }
        .actions {
          @include media-breakpoint-down(sm) {
            margin-top: 2.5em;
          }
        }
      }
      .genres .form {
        /*
        flex: 1.5;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: start;
        padding-left: 0;
        */
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding-bottom: 3em;
        padding-left: 0;
        @include media-breakpoint-down(sm) {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          padding: 0 1em;
          padding-bottom: 1em;
        }

        // override standard bootstrap for just this case
        .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
          background-image: linear-gradient(107deg, $darkish-pink, $blue-purple);
          color: $bluish-white;
        }

        .btn {
          color: black;
          background: white;
          box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.64);
          margin: 5px;
        }
      }
    }
  }
</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import LinkButton from '@/components/widgets/LinkButton'

import { mapGetters } from 'vuex'

import { validationMixin } from 'vuelidate'
import { required, email, minLength, helpers } from 'vuelidate/lib/validators'

import { genres, moods } from '@/store/modules/tag'

const validHandle = helpers.regex('validHandle', /^[a-z0-9]+$/)
const mustBeChecked = value => value

export default {
  name: 'Onboarding',
  components: {
    FontAwesomeIcon,
    VueGoogleAutocomplete,
    LinkButton
  },
  mixins: [validationMixin],
  validations: {
    artist: {
      name: {
        required
      },
      handle: {
        required,
        validHandle,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      tos: {
        mustBeChecked
      }
    }
  },
  data () {
    const isArtist = this.$store.getters['profile/isArtist']
    const artist = isArtist ? this.$store.getters['artist/artist'] : {tags: []}

    let genreMap = {}
    for (let g of genres) {
      genreMap[g] = artist.tags.indexOf(g) !== -1
    }

    let moodMap = {}
    for (let m of moods) {
      moodMap[m] = artist.tags.indexOf(m) !== -1
    }

    return {
      newlyCreated: false,
      step: isArtist ? 'payout' : 'create',
      errors: {},
      genres: genres,
      moods: moods,
      genreMap: genreMap,
      moodMap: moodMap
    }
  },
  computed: {
    ...mapGetters('profile', ['currentUser', 'displayName', 'isArtist']),
    ...mapGetters('artist', ['artist', 'hasPayoutMethod']),
    selectedMoods () {
      let tags = []
      for (let tag in this.moodMap) {
        if (this.moodMap[tag]) {
          tags.push(tag)
        }
      }
      return tags
    },
    selectedGenres () {
      let tags = []
      for (let tag in this.genreMap) {
        if (this.genreMap[tag]) {
          tags.push(tag)
        }
      }
      return tags
    }
  },
  async created () {
    await this.$store.dispatch('profile/getCurrentUser')

    if (this.isArtist && this.hasPayoutMethod) {
      if (this.$route.query.payout_success) {
        this.$store.dispatch('flash/showMessage', {message: 'Welcome Artist'})
      }
      this.$router.push({name: 'artist-profile-edit'})
    }

    if (!this.isArtist) {
      if (!this.artist.handle) this.artist.handle = this.currentUser.username
      if (!this.artist.email) this.artist.email = this.currentUser.email
    }
  },
  methods: {
    close () {
      this.$router.push({name: 'fan-home'})
    },
    create () {
      this.errors = {}

      window.$v = this.$v
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.errors.name = this.$v.artist.name.$error ? 'Name is required' : undefined
        this.errors.handle = this.$v.artist.handle.$error ? 'Invalid handle (lowercase letters only)' : undefined
        this.errors.email = this.$v.artist.email.$error ? 'Invalid email' : undefined
        return
      }

      let errors = {}

      // If Google Maps API failed let's just copy the location manually entered, work around the limitations
      // of vue-google-autocomplete
      if (!this.artist.location) {
        let raw = document.querySelector('input#location').value
        if (raw) this.artist.location = raw.trim()
      }

      this.$store.dispatch('artist/createArtist', this.artist)
        .then(() => {
          this.$store.dispatch('profile/getCurrentUser')
        })
        .then(() => {
          this.newlyCreated = true
          this.step = 'genres'
        })
        .catch(err => {
          for (let field in err.response.data) {
            errors[field] = err.response.data[field]
          }
          this.errors = errors
        })
    },
    fieldState (name) {
      return this.errors[name] ? 'invalid' : null
    },
    fieldError (name) {
      return this.errors[name] || null
    },
    onPlaceChanged (addr, place, id) {
      this.artist.location_lat = addr.latitude
      this.artist.location_lng = addr.longitude
      this.artist.location = place.formatted_address
    },
    onGenre (genre) {
      let genres = this.selectedGenres

      if ((genres.length > 3) && (genres.indexOf(genre) !== -1)) {
        this.genreMap[genre] = false
      }
    },
    onMood (mood) {
      let moods = this.selectedMoods

      if ((moods.length > 2) && (moods.indexOf(mood) !== -1)) {
        this.moodMap[mood] = false
      }
    },
    saveGenres () {
      let tags = []
      for (let tag of this.artist.tags) {
        // don't remove non-genre tags on the artist
        if (genres.indexOf(tag) === -1) {
          tags.push(tag)
        }
      }
      for (let tag in this.genreMap) {
        // use selected tags
        if (this.genreMap[tag]) {
          tags.push(tag)
        }
      }
      this.artist.tags = tags
      this.$store.dispatch('artist/updateArtist').then(() => {
        this.step = 'moods'
      })
    },
    saveMoods () {
      let tags = []
      for (let tag of this.artist.tags) {
        // don't remove non-mood tags on the artist
        if (moods.indexOf(tag) === -1) {
          tags.push(tag)
        }
      }
      for (let tag in this.moodMap) {
        // use selected tags
        if (this.moodMap[tag]) {
          tags.push(tag)
        }
      }
      this.artist.tags = tags
      this.$store.dispatch('artist/updateArtist').then(() => {
        this.step = 'payout'
      })
    },
    async setupStripe () {
      const link = await this.$store.dispatch('payment/getArtistPayoutSetupLink', {
        next: window.location.origin + '/artist/dashboard/'
      })
      window.location = link
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/Onboarding.vue